import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export type DocBatchItem = { id: string; name: string; type: string | null };

export function useGetDocsBatch(matterId: string | null | undefined, docIds: string[]) {
  const { getFetchConfig } = useGetFetchConfig();

  return useQuery<DocBatchItem[], Error>(
    [QueryEntity.Doc, { matterId, docIds }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/docs/batch`,
        getFetchConfig({ method: FetchMethod.POST, data: { docIds } }),
      );
      if (!res.ok) throw new Error('Failed to fetch docs');
      return res.json();
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!matterId && docIds.length > 0,
      keepPreviousData: true,
    },
  );
}
